import { useEffect } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/site/ScrollToTop";
import AnalyticsRouteTracker from "@/components/site/AnalyticsRouteTracker";
import RheaChat from "@/components/site/RheaChat";
import AppRoutes from "@/AppRoutes";

function startSmoothScroll() {
  const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
  let frameId;
  const renderFrame = (time) => {
    lenis.raf(time);
    frameId = requestAnimationFrame(renderFrame);
  };
  frameId = requestAnimationFrame(renderFrame);
  return () => {
    cancelAnimationFrame(frameId);
    lenis.destroy();
  };
}

function SmoothScroll() {
  useEffect(() => startSmoothScroll(), []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnalyticsRouteTracker />
      <SmoothScroll />
      <AppRoutes />
      <RheaChat />
      <Toaster richColors closeButton position="top-right" />
    </BrowserRouter>
  );
}

export default App;
